export const fadeChangeMotion = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
  transition: { duration: 0.35, ease: [0, 0.71, 0.2, 1.01], delay: 0.1 },
};

export const slowFadeChangeMotion = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
  transition: { duration: 1.5, delay: 0.5 },
};

export const heightChangeMotion = {
  initial: {
    opacity: 0,
    height: 0,
  },
  animate: {
    opacity: 1,
    y: 0,
    height: 'auto',
  },
  exit: {
    opacity: 0,
    height: 0,
  },
  transition: { duration: 0.25 },
};

export const fadeInOutMotion = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
  transition: { duration: 0.25 },
};

export const slideUpMotion = {
  initial: {
    opacity: 0,
    y: 15,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -15,
  },
  transition: { duration: 0.25 },
};

export const slidePageMotion = {
  initial: {
    opacity: 0,
    y: 15,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 15,
  },
  transition: { duration: 0.45 },
};

export const slideUIMotion = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 20,
  },
  transition: { duration: 0.45 },
};

export const slideFastPageMotion = {
  initial: {
    opacity: 0,
    y: 15,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 15,
  },
  transition: { duration: 0.25 },
};

export const slideUpDownMotion = {
  initial: {
    opacity: 0,
    y: 10,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -10,
  },
  transition: { duration: 0.35 },
};
